export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-900">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-accent-500">
                <i className="ri-film-line text-lg md:text-xl text-foreground-950"></i>
              </div>
              <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">
                无极电影网
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              无极电影网提供最新电影大全，新片速递免费在线看，热门电影高清不缓冲，院线大片蓝光极速播放，海量影片每日更新。
            </p>
            <div className="flex items-center gap-3">
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-600 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-600 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-600 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-600 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-800 mb-4">快速导航</h3>
            <div className="flex flex-col gap-2.5">
              <a href="#ranking" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap">热播榜单</a>
              <a href="#updates" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap">新片速递</a>
              <a href="#cards" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap">热门电影</a>
              <a href="#features" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap">极速播放</a>
              <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-800 mb-4">电影分类</h3>
            <div className="flex flex-col gap-2.5">
              <a href="#index" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap">动作冒险</a>
              <a href="#index" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap">科幻巨制</a>
              <a href="#index" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap">喜剧搞笑</a>
              <a href="#index" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap">恐怖惊悚</a>
              <a href="#index" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap">悬疑推理</a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-800 mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              感谢所有合作伙伴对无极电影网的支持与信赖。诚邀更多优质内容方加入我们，共同为影迷提供更好的观影体验。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800/60">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-600">
              &copy; 2018-2026 无极电影网 wujimovie.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-foreground-600 hover:text-foreground-800 transition-colors whitespace-nowrap">服务条款</a>
              <a href="#hero" className="text-xs text-foreground-600 hover:text-foreground-800 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#hero" className="text-xs text-foreground-600 hover:text-foreground-800 transition-colors whitespace-nowrap">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}